import { InfoLayout } from "../../components/InfoLayout";

export function MasteryPage() {
  return (
    <InfoLayout
      title="Progress & mastery"
      lead="PyDialog tracks understanding at the level of individual objectives — not just a single lesson score — so you always know exactly what to work on next."
    >
      <div className="card">
        <h3>Per-objective scoring</h3>
        <p>
          Every lesson is broken into learning objectives. Each dialogue answer is
          scored from 0 to 100% against the objective it targets, and those scores
          roll up into an objective mastery level. An objective counts as{" "}
          <strong>mastered at 70%</strong>.
        </p>
      </div>

      <div className="card">
        <h3>Best score, attempts &amp; trend</h3>
        <p>
          For each lesson we keep your best score, how many attempts you've taken,
          and whether your understanding is <strong>improving</strong>,{" "}
          <strong>steady</strong>, or <strong>declining</strong> across attempts.
          Your full attempt history is preserved — nothing is thrown away.
        </p>
      </div>

      <div className="card">
        <h3>Attempts &amp; unlocking</h3>
        <p>
          You get a set number of attempts at a lesson (three by default), and
          they count whether or not you pass. Once they're used up the lesson
          locks until your instructor resets it — a signal that it's time to ask
          for help rather than keep guessing.
        </p>
      </div>

      <div className="card">
        <h3>Misconceptions, not just marks</h3>
        <p>
          Where an answer reveals a specific incorrect belief, it's flagged as a
          named misconception rather than a vague "wrong". Fixing those is the
          fastest route to real mastery.
        </p>
      </div>
    </InfoLayout>
  );
}
